import React, { useState, useRef, useEffect } from "react";
import styles from "./ReelsCategoryUpsert.module.css";
import { PostRadioButton, Header, Footer, useConfirm } from "@/components";
import { AxiosForm } from "@/Axios";
import { useNavigate, useParams } from "react-router-dom";
import { INSERT_TAG } from "..";
import { decoded } from "@/utils";
import {
  useLoadReset,
  useDebouncedCallback,
  useDimLoading,
  useDimLoadComplete,
} from "@/hooks";

export default function ReelsCategoryUpsert() {
  const dimLoading = useDimLoading();
  const dimLoadComplete = useDimLoadComplete();
  const loadReset = useLoadReset();
  const { tag, info } = useParams();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const defaultState = {
    categoryNm: "",
    imageFile: {},
    description: "",
    isView: true,
    preview: "",
    headerTitle: "릴스 카테고리 등록",
    hasImage: false,
    buttonNm: "등록",
    isInsert: true,
    id: "",
  };
  const [state, setState] = useState(defaultState);
  const resetState = () => {
    setState(defaultState);
    loadReset();
  };
  const fileRef = useRef();

  const triggerFileInput = () => {
    if (!state.preview) {
      fileRef.current.click();
    }
  };
  const fileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setState((s) => ({
        ...s,
        imageFile: file,
        preview: URL.createObjectURL(file),
        hasImage: true,
      }));
    }
    // 파일 선택 후 초기화
    e.target.value = "";
  };
  const removeImage = () => {
    setState((s) => ({ ...s, imageFile: {}, preview: "" }));
  };
  const changeCategoryName = (e) => {
    setState((s) => ({ ...s, categoryNm: e.target.value }));
    if (e.key === "Enter") {
      e.target.blur();
    }
  };
  const changeDescription = (e) => {
    setState((s) => ({ ...s, description: e.target.value }));
    if (e.key === "Enter") {
      e.target.blur();
    }
  };
  const radioOnOff = (onOff) => {
    setState((s) => ({ ...s, isView: onOff }));
  };
  const insert = useDebouncedCallback(() => {
    const formData = new FormData();
    formData.append("imageFile", state.imageFile);
    formData.append("categoryNm", state.categoryNm);
    formData.append("description", state.description);
    formData.append("isView", state.isView);

    dimLoading();
    AxiosForm.post("/api/reels-category/insert", formData).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete(() => {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        });
        return;
      }
      dimLoadComplete(() => {
        confirm(
          `등록이 완료되었습니다.\n확인을 누르면 카테고리로 이동합니다.`,
          () => {
            navigate("/reels-category", { replace: true });
          }
        );
      });
    });
  });

  const update = useDebouncedCallback(() => {
    const formData = new FormData();
    if (state.hasImage) {
      formData.append("imageFile", state.imageFile);
    }
    formData.append("hasImage", state.hasImage);
    formData.append("categoryNm", state.categoryNm);
    formData.append("description", state.description);
    formData.append("isView", state.isView);
    formData.append("index", state.id);

    dimLoading();
    AxiosForm.post("/api/reels-category/update", formData).then((res) => {
      if (res.data?.errMsg) {
        dimLoadComplete(() => {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        });
        return;
      }
      dimLoadComplete(() => {
        confirm(
          `수정이 완료되었습니다.\n확인을 누르면 카테고리로 이동합니다.`,
          () => {
            navigate("/reels-category", { replace: true });
          }
        );
      });
    });
  });
  useEffect(() => {
    if (tag === INSERT_TAG) {
      return resetState;
    }

    const data = decoded(info, true);
    setState((s) => ({
      ...s,
      categoryNm: data.categoryNm,
      imageFile: {},
      description: data.description,
      isView: true,
      preview: data.image,
      headerTitle: "릴스 카테고리 수정",
      buttonNm: "수정",
      isInsert: false,
      id: data.id,
    }));
    return resetState;
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Header title={state.headerTitle} isShare={false} />
        <div className={styles.infoInputArea}>
          <div className={styles.categoryName}>
            <div className={styles.starIcon} />
            <div className={styles.categoryInput}>
              <input
                className={styles.categoryInputInput}
                placeholder="카테고리명을 입력해주세요"
                defaultValue={state.categoryNm}
                onKeyUp={(e) => {
                  changeCategoryName(e);
                }}
              />
            </div>
          </div>
          <div className={styles.mainImage}>
            <div className={styles.mainImageContainer}>
              <div className={styles.starIcon1} />
              <div
                className={styles.mainImageInputArea}
                onClick={triggerFileInput}
              >
                <div className={styles.inputPlaceholder}>
                  {!state.preview && (
                    <span className={styles.mainImageMessage}>
                      대표 이미지를 설정해주세요
                    </span>
                  )}
                  {state.preview && (
                    <img
                      className={styles.preview}
                      src={state.preview}
                      alt="미리보기"
                    />
                  )}
                </div>
                <input
                  ref={fileRef}
                  type="file"
                  accept="image/*"
                  className={styles.mainInput}
                  onChange={(e) => {
                    fileChange(e);
                  }}
                />
                <div className={styles.imageArea}>
                  {!state.preview && <div className={styles.uploadIcon} />}
                  {state.preview && (
                    <button className={styles.cancelBtn} onClick={removeImage}>
                      <span className={styles.cancel}>X</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.categoryDescription}>
            <div className={styles.descriptionInput}>
              <div className={styles.inputPlaceholder2}></div>
              <input
                type="text"
                className={styles.descriptionInput3}
                placeholder="카테고리에 대한 설명을 입력해주세요"
                defaultValue={state.description}
                onKeyUp={(e) => {
                  changeDescription(e);
                }}
              />
            </div>
          </div>
          <div className={styles.publishArea}>
            <div className={styles.starIcon4} />
            <PostRadioButton
              postClick={() => {
                radioOnOff(true);
              }}
              notPostClick={() => {
                radioOnOff(false);
              }}
            />
          </div>
        </div>
        <div className={styles.registerButtonArea}>
          <button
            className={styles.registerButton}
            onClick={state.isInsert ? insert : update}
          >
            <span className={styles.register}>{state.buttonNm}</span>
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
}
